module.exports = __webpack_public_path__ + "audio-34ccc4db7708.m4a";